import { jsx as n, jsxs as W } from "react/jsx-runtime";
import { useWatch as d, UnprocessableContentError as _ } from "@systemeio/util";
import { ContactSlugEnum as a } from "@systemeio/ui";
import { useState as m } from "react";
import z from "../../components/card-wrapper.mjs";
import H from "../../components/field.mjs";
import N from "../../components/item-thumbnail-base.mjs";
import P from "../../ui-kit/theme-button.mjs";
import { getDefaultFieldValues as C } from "../../utils/get-default-field-values.mjs";
import { useHandleOptin as U } from "./api/index.mjs";
import { useVisitorInfoStore as Z } from "../../store/index.mjs";
import { StoreImageEnum as $ } from "../../enums/store-image-enum.mjs";
const tt = ({
  id: i,
  title: O,
  subTitle: x,
  thumbnail: E,
  fields: u,
  buttonTitle: F,
  thankYouPage: c,
  headingLevel: I
}) => {
  const [S, l] = m(!1), [p, f] = m({}), [r, s] = m(
    C(u)
  ), { handleOptin: j } = U(), { visitorInfo: T } = Z();
  d(u, (t) => s(C(t))), d(T, (t) => {
    if (!t) return;
    const e = r[a.Country], o = Object.prototype.hasOwnProperty.call(r, a.Country) && !(e != null && e.value);
    t.country && o && e && s({
      ...r,
      [a.Country]: {
        ...e,
        value: t.country
      }
    });
  });
  const w = async () => {
    var e;
    if (!i) return;
    const t = Object.values(r).map((o) => ({
      slug: o.slug,
      value: o.value ?? ""
    }));
    try {
      f({}), l(!0);
      const o = Intl.DateTimeFormat().resolvedOptions().timeZone;
      await j({
        itemOptIn: `/api/dashboard/digital-store/item-opt-ins/${i}`,
        values: t,
        timezone: o
      }), c.path && window.location.assign(c.path);
    } catch (o) {
      o instanceof _ && ((e = o.errors.violations) == null || e.forEach((h) => {
        var y;
        const D = /values\[(\d+)]/, g = h.propertyPath.match(D);
        if (g) {
          const B = parseInt(g[1]), b = (y = t.find((v, V) => V === B)) == null ? void 0 : y.slug;
          b && f((v) => ({ ...v, [b]: h.message }));
        }
      }));
    } finally {
      l(!1);
    }
  };
  return /* @__PURE__ */ n(z, { children: /* @__PURE__ */ W(
    "form",
    {
      onSubmit: (t) => {
        t.preventDefault(), w();
      },
      className: "flex flex-col gap-3",
      children: [
        /* @__PURE__ */ n(
          N,
          {
            title: O,
            subTitle: x,
            imageType: $.optin_thumbnail,
            thumbnail: E,
            headingLevel: I
          }
        ),
        Object.values(r).map((t) => {
          const e = (o) => s({
            ...r,
            [t.slug]: { ...t, value: o }
          });
          return /* @__PURE__ */ n(
            H,
            {
              contactFields: r,
              field: t,
              value: t.value,
              error: p[t.slug] ? [p[t.slug] ?? ""] : [],
              onChange: e
            },
            t.slug
          );
        }),
        /* @__PURE__ */ n(P, { isFetching: S, type: "submit", children: F })
      ]
    }
  ) });
};
export {
  tt as default
};
